import { useState } from "react";
import { Table, Tbody, Td, Th, Thead, Tr, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Pagination from "components/ui/pagination/Pagination";

export default function BranchesDataTable({ data }) {
  console.log(data);
  const { t } = useTranslation();
  /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
  const recordsPerPage = 10;
  const [currentPageActive, setCurrentPageActive] = useState(1);
  const prePage = (currentPage, setCurrentPage) => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = (currentPage, setCurrentPage, npage) => {
    if (currentPage < npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const calculateRecords = (data, currentPage, recordsPerPage) => {
    const firstIndex = (currentPage - 1) * recordsPerPage;
    const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
    return data?.slice(firstIndex, lastIndex);
  };

  // Calculate records for activeDiscounts
  const branchesDashbordData = calculateRecords(
    data,
    currentPageActive,
    recordsPerPage
  );
  /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return (
    <>
      <Table>
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>{t("pages.reports.reports_tables.branch")}</Th>
            <Th>{t("pages.dashboard.ACTIVE_ORDERS")}</Th>
            <Th>{t("pages.dashboard.ACTIVE_ORDERS_AMOUNT")}</Th>
            <Th>{t("pages.dashboard.OCCUPIED_TABLES")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {branchesDashbordData?.map((item, index) => (
            <Tr key={index}>
              <Td>{index + 1}</Td>
              <Td>{item?.BranchName}</Td>
              <Td>{item?.BranchActiveOrders[0]?.BranchActiveOrders}</Td>
              <Td>{item?.BranchActiveOrders[0]?.BranchActiveOrdersAmount}</Td>
              <Td>{item?.BranchOccupiedTables[0]?.BranchOccupiedTables}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Pagination
        currentPage={currentPageActive}
        setCurrentPage={setCurrentPageActive}
        npage={Math.ceil(data?.length / recordsPerPage)}
        prePage={() => prePage(currentPageActive, setCurrentPageActive)}
        nextPage={() =>
          nextPage(
            currentPageActive,
            setCurrentPageActive,
            Math.ceil(data?.length / recordsPerPage)
          )
        }
      />
    </>
  );
}
